import React from 'react'
import {BrowserRouter, Switch, Route} from 'react-router-dom'

import Home from '../french/pages/home/Home'
import Contact from '../french/pages/contact/Contact'
import Donations from '../french/pages/donations/Donations'
import Gallery from '../french/pages/gallery/Gallery'
import Menu from '../french/menus/Menu'
import MenuGap from '../french/menus/MenuGap'
import Footer from '../french/footers/Footer'

import AOS from 'aos'
import 'aos/dist/aos.css'


AOS.init({
    anchorPlacement: 'top-bottom',
})


const Router = () => {
    
    return(
        <BrowserRouter>
            <Menu/>
            <MenuGap/>
            <Switch>
                <Route exact path="/acceuil" component={() => <Home/>}/>
                <Route exact path="/contact" component={() => <Contact/>}/>
                <Route exact path="/donations" component={() => <Donations/>}/>
                <Route exact path="/galerie" component={() => <Gallery/>}/>
                <Route path="/" component={() => <Home/>}/>
            </Switch>
            <Footer/>
        </BrowserRouter>
    )
}

export default Router